import React from "react";
import Typography from "@material-ui/core/Typography";
import intl from "react-intl-universal";

import { Checkbox } from "components/Checkbox";

import { EditorGrid } from "../EditorGrid";
import { FIELD } from "../../constants";

interface IThreatFieldProps {
  label?: string;
}

export const ThreatField = ({
  label = "STAT_FORM_LABEL_THREAT",
}: IThreatFieldProps) => {
  return (
    <>
      <EditorGrid centerAlign item xs={2}>
        <Typography variant="h3">{intl.get(label)}</Typography>
      </EditorGrid>
      <EditorGrid item xs={10}>
        <Checkbox name={FIELD.threat} inFormik />
      </EditorGrid>
    </>
  );
};
